module.exports = __webpack_public_path__ + "img/slide5.ad465716.jpg";